/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedContactSellerButton_user = {
    readonly " $fragmentRefs": FragmentRefs<"SharedContactDealerWrapper_user">;
    readonly " $refType": "PdpSharedContactSellerButton_user";
};
export type PdpSharedContactSellerButton_user$data = PdpSharedContactSellerButton_user;
export type PdpSharedContactSellerButton_user$key = {
    readonly " $data"?: PdpSharedContactSellerButton_user$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedContactSellerButton_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedContactSellerButton_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedContactDealerWrapper_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'b7a4002a8396ac27cdb6d4659abd4c39';
export default node;
